//Generator Url: http://localhost:8033/api/FrontDashboard/GetApi
import request from '~/utils/request';
//import './FrontDashboardApi.d';
export namespace FrontDashboardApi {
    /**erp快捷版同用*/
    export const getCurrentRate = (loadingOptions?: IRequestLoadingOption) => request<IExchangeRateLastResult>({
        method: 'post',
        url: 'FrontDashboard/GetCurrentRate',
        loadingOptions
    })

    export const getCustomsRate = (loadingOptions?: IRequestLoadingOption) => request<IDateExchangeRateResult>({
        method: 'get',
        url: 'FrontDashboard/GetCustomsRate',
        loadingOptions
    })

    export const getMonthExchangeRateAsync = (loadingOptions?: IRequestLoadingOption) => request<IExchangeRateLastResult>({
        method: 'post',
        url: 'FrontDashboard/GetMonthExchangeRateAsync',
        loadingOptions
    })

    // ------------ model define ------------- //


    export interface IExchangeRateLastResult {
        /**美元USD
        *System.Decimal*/
        USD: number

        USD_Current?: NString
        /**港币HKD
        *System.Decimal*/
        HKD: number

        HKD_Current?: NString
        /**欧元EUR
        *System.Decimal*/
        EUR: number

        EUR_Current?: NString
        /**英镑GBP
        *System.Decimal*/
        GBP: number

        GBP_Current?: NString
        /**日元JPY
        *System.Decimal*/
        JPY: number

        JPY_Current?: NString
        /**瑞士法郎CHF
        *System.Decimal*/
        CHF: number

        CHF_Current?: NString

        RateDate?: NString
        /**当前的服务器时间
        *System.DateTime*/
        ServerTime?: NString
    }


    export interface IDateExchangeRateResult {
        /**1.中行汇率 2.海关汇率
        *System.Int32*/
        BankType: number
        /**美元USD
        *System.Decimal*/
        USD: number
        /**港币HKD
        *System.Decimal*/
        HKD: number
        /**欧元EUR
        *System.Decimal*/
        EUR: number
        /**英镑GBP
        *System.Decimal*/
        GBP: number
        /**日元JPY
        *System.Decimal*/
        JPY: number
        /**瑞士法郎CHF
        *System.Decimal*/
        CHF: number
        /**提交时间
        *System.DateTime*/
        PostedAt?: NString
    }

}
export default FrontDashboardApi